import { ModuleLayout } from "layouts";
import AllFeedbacks from "./AllFeedbacks";

function Customers() {
  return (
    <ModuleLayout title="All Feedbacks">
      <AllFeedbacks />
    </ModuleLayout>
  );
}
export default Customers;
